<template>
  <div class="snackbar-container text-center ma-2">
    <v-snackbar
      v-model="payload.show"
      :timeout="timeout"
    >
      {{ text }}
      {{ formattedCountdown }}
      <v-icon
        color="white"
        class="close"
        @click="payload.show = false"
      >
        mdi-close
      </v-icon>
    </v-snackbar>
  </div>
</template>

<script>
import moment from 'moment/moment';

export default {
    name: 'Snackbar',
    data() {
        return {
            text: this.$t('administration.maintenanceMessage'),
            timeout: 0,
            countdown: 0,
            payload: {},
            schedule: 0,
            countdownTimer: 0,
            formattedCountdown: '',
        };
    },
    watch: {
        countdown() {
            this.formattedCountdown = this.formatCountdown();
        },
    },
    created() {
        this.$store.subscribe(mutation => {
            if (mutation.type === 'setMaintenanceData') {
                const { payload } = mutation;
                if (mutation.payload.show) {
                    localStorage.setItem('maintenanceStatus', JSON.stringify(payload));
                    this.timeout = 0;
                    this.countdown = 0;
                    this.payload = {};
                    this.setMaintenanceData(payload);
                }
            }
        });
    },
    mounted() {
        const payload = JSON.parse(localStorage.getItem('maintenanceStatus') || '{}');
        const wait = this.getWaitTime(payload);
        if (wait > 0) {
            this.setMaintenanceData(payload);
        }
    },
    methods: {
        getWaitTime(payload) {
            return payload.time - moment.utc().unix();
        },
        setMaintenanceData(payload) {
            clearTimeout(this.schedule);
            clearInterval(this.countdownTimer);
            const timeout = this.getWaitTime(payload);
            this.timeout = (timeout - 1) * 1000;
            this.countdown = timeout - 1;
            this.schedule = setTimeout(() => {
                this.payload = payload;
                this.countDown();
            }, 0);
        },
        countDown() {
            if (this.timeout > 0) {
                this.countdownTimer = setInterval(() => {
                    if (this.countdown <= 0) {
                        clearInterval(this.countdownTimer);
                    } else {
                        this.countdown -= 1;
                    }
                }, 1000);
            }
        },
        formatCountdown() {
            const hours = Math.floor(this.countdown / 3600);
            const minutes = Math.floor((this.countdown % 3600) / 60);
            const seconds = Math.floor(this.countdown % 60);
            let output = `${seconds}s`;
            if (minutes >= 1) {
                output = `${minutes}M${output}`;
            }
            if (hours >= 1) {
                output = `${hours}H:${output}`;
            }
            return output;
        },
    },
};
</script>

<style lang="scss" scoped>
.snackbar-container {
    ::v-deep .v-snack__content {
        position: relative;
    }

    .close {
        position: absolute;
        right: 12px;
        padding: 0.5rem;
        border-radius: 50%;

        &:hover {
            background-color: #4b4b4b;
        }
    }
}
</style>
